import React, { useState } from 'react';
import { 
  Paper, 
  Typography, 
  Box,
  Card, 
  CardContent,
  CardMedia,
  Grid,
  Button,
  Tabs,
  Tab,
  Chip,
  Stack,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import styles from '../styles/components/InsuranceShowcase.module.css';

const InsuranceShowcase = () => {
  const { t } = useTranslation();
  const [selectedCompany, setSelectedCompany] = useState(0);

  const insuranceProducts = [
    {
      id: '1',
      company: 'Company A',
      name: t('insurance.product1.name'),
      description: t('insurance.product1.description'),
      features: [
        t('insurance.product1.feature1'),
        t('insurance.product1.feature2'),
        t('insurance.product1.feature3'),
      ],
      imageUrl: '/path-to-image1.jpg',
      price: '$29.99',
      tag: 'Most Popular',
    },
    // Add more products as needed
  ];

  const companies = insuranceProducts
    .map(product => product.company)
    .filter((company, index, self) => self.indexOf(company) === index);

  const handleCompanyChange = (_event: React.SyntheticEvent, newValue: number) => {
    setSelectedCompany(newValue);
  };

  return (
    <Paper elevation={0} className={styles.container}>
      <Typography variant="h4" gutterBottom className={styles.title}>
        {t('insurance.title')}
      </Typography>
      
      <Tabs
        value={selectedCompany}
        onChange={handleCompanyChange}
        variant="scrollable"
        scrollButtons="auto"
        className={styles.tabs}
      >
        {companies.map((company, index) => (
          <Tab key={index} label={company} />
        ))}
      </Tabs>

      <Grid container spacing={4}>
        {insuranceProducts
          .filter(product => product.company === companies[selectedCompany])
          .map(product => (
            <Grid item xs={12} sm={6} md={4} key={product.id}>
              <Card className={styles.card}>
                {product.tag && (
                  <Chip label={product.tag} color="secondary" className={styles.tag} />
                )}
                <CardMedia
                  component="img"
                  height="200"
                  image={product.imageUrl}
                  alt={product.name}
                  className={styles.cardMedia}
                />
                <CardContent className={styles.cardContent}>
                  <Typography variant="h5" className={styles.productName}>
                    {product.name}
                  </Typography>
                  <Typography variant="body1" color="text.secondary" paragraph>
                    {product.description}
                  </Typography>
                  <Stack className={styles.featureList}>
                    {product.features.map((feature, index) => (
                      <Box key={index} className={styles.featureItem}>
                        <Box className={styles.featureDot} />
                        <Typography variant="body2">{feature}</Typography>
                      </Box>
                    ))}
                  </Stack>
                  <Box className={styles.priceContainer}>
                    <Typography variant="h6" className={styles.price}>
                      {product.price}
                      <Typography component="span" variant="body2" className={styles.priceUnit}>
                        /month
                      </Typography>
                    </Typography>
                    <Button 
                      variant="contained" 
                      color="primary"
                      className={styles.learnMoreButton}
                    >
                      {t('insurance.learnMore')}
                    </Button>
                  </Box>
                </CardContent>
              </Card>
            </Grid>
          ))}
      </Grid>
    </Paper>
  );
};

export default InsuranceShowcase; 